var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{staticClass:"max-width",attrs:{"fluid":""}},[_c('loader-vue',{attrs:{"loading":!_vm.profile}},[(_vm.profile)?_c('div',[_vm._v(_vm._s(_vm.profile.values.about))]):_vm._e()])],1)}
var staticRenderFns = []

export { render, staticRenderFns }